export default [
  {
    path: '/register',
    name: 'register',
    component: () => import('@/views/register/Register.vue'),
    meta: {
      layout: 'full',
      resource: 'auth',
      pageTitle: 'breadcrumb.register',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/register/verify',
    name: 'register-verify',
    component: () => import('@/views/register/RegisterVerify.vue'),
    meta: {
      layout: 'full',
      resource: 'auth',
      pageTitle: 'breadcrumb.verifyAccount',
    },
  },
]
